import { useAuth } from '../auth/AuthProvider';
import { Logo } from '../components/Logo';
import { useProfile } from '../profile/ProfileProvider';
import { Loading } from '../components/Loading';

export function InactivePage() {
  const { signOut } = useAuth();
  const { state } = useProfile();
  // A new hire's first sign-in (Oct 2026): the server activates the prepared account within seconds and the
  // profile listener picks it up, so show a short "setting up" state instead of "deactivated".
  if (state.status === 'inactive' && state.user.newHire === true) {
    return (
      <main className="min-h-screen flex items-center justify-center px-6">
        <div className="w-full max-w-md space-y-6 text-center">
          <div className="flex justify-center"><Logo themed className="h-7" /></div>
          <p className="text-sm text-fg-muted">Welcome to DAAily. We are setting up your account, this takes a few seconds.</p>
          <Loading label="your account" />
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md space-y-10">
        <div className="flex justify-center">
          <Logo themed className="h-7" />
        </div>

        <div className="space-y-4 border-hairline border-line p-8">
          <h1 className="font-display text-xl tracking-tightest">
            Account inactive
          </h1>
          <p className="text-sm text-fg-muted leading-relaxed">
            Your account has been deactivated. If this is unexpected, please
            contact{' '}
            <a
              href="mailto:hr@daaily.com"
              className="text-fg underline underline-offset-2"
            >
              hr@daaily.com
            </a>
            .
          </p>
        </div>

        <div className="text-center">
          <button
            type="button"
            onClick={() => void signOut()}
            className="text-xs text-fg-muted hover:text-fg transition-colors tracking-tighter"
          >
            Sign out
          </button>
        </div>
      </div>
    </main>
  );
}
